import { FormProvider } from "react-hook-form";
import { nameof } from "ts-simple-nameof";
import styles from "./NapSettingsSection.module.scss";
import { useMyNapSettingsForm } from "../hooks/useMyNapSettingsForm";
import { IMyNapSettingsFormModel } from "../models/myNapSettingsFormModel";
import { DefaultFormSelectField } from "../../../../common/components/forms/inputs/dropdown/DefaultFormSelectField";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { MessageBanner } from "../../../../common/components/common/MessageBanner/MessageBanner";
import { NapVatStatus } from "../../../../common/enums";
import { NapVatStatusLabels } from "../../../../common/labels";

const napVatOptions = [
  { id: NapVatStatus.Registered, name: NapVatStatusLabels[NapVatStatus.Registered] },
  { id: NapVatStatus.Article97a, name: NapVatStatusLabels[NapVatStatus.Article97a] },
  { id: NapVatStatus.NotRegistered, name: NapVatStatusLabels[NapVatStatus.NotRegistered] },
];

export const NapSettingsSection = () => {
  const { form, isLoading, isSaving, onSubmit } = useMyNapSettingsForm();

  if (isLoading) {
    return <div className={styles.loading}>Зарежда...</div>;
  }

  return (
    <div className={styles.root}>
      <MessageBanner
        type="info"
        width="100%"
        message="Данните по-долу се използват за НАП одиторския файл (Приложение №38) за всички ваши обекти. Попълнете ги според заявлението за регистриране на онлайн магазин, подадено към НАП."
      />

      <FormProvider {...form}>
        <form onSubmit={onSubmit} noValidate className={styles.form}>
          <DefaultFormSelectField
            name={nameof<IMyNapSettingsFormModel>((x) => x.vatStatus)}
            label="ДДС статус (за НАП)"
            tooltip="Регистриран по ДДС → начислява се 20%. По чл. 97а → специфичен режим. Нерегистриран → ДДС = 0."
            options={napVatOptions}
            includeId={false}
            width="100%"
            required
          />
          <DefaultInputField
            name={nameof<IMyNapSettingsFormModel>((x) => x.merchantEik)}
            label="ЕИК на фирмата"
            placeholder="напр. 123456789"
            width="100%"
            required
          />
          <DefaultInputField
            name={nameof<IMyNapSettingsFormModel>((x) => x.shopUin)}
            label="УИН на е-магазина (от НАП)"
            placeholder="УИН от регистрацията в НАП"
            width="100%"
            required
          />
          <DefaultInputField
            name={nameof<IMyNapSettingsFormModel>((x) => x.shopDomain)}
            label="Домейн на е-магазина"
            placeholder="example.com"
            width="100%"
            required
          />
          <DefaultInputField
            name={nameof<IMyNapSettingsFormModel>((x) => x.vposNumber)}
            label="Номер на виртуален ПОС (незадължително)"
            placeholder="Номер на ВПОС"
            width="100%"
          />
          <DefaultButton
            label="Запази"
            type="submit"
            design="accent"
            loading={isSaving}
            width="100%"
          />
        </form>
      </FormProvider>
    </div>
  );
};
